import { RatingStatuses } from '../../../utils/constants';

export const colorBallDescriptions = {
    R1: 'players learning the fundamentals at the start of their tennis journey',
    O1: 'players developing their skills at the midway point towards playing with yellow ball',
    O2: 'players developing their skills at the midway point towards playing with yellow ball',
    G1: 'players who are almost ready to compete with yellow balls',
    G2: 'players who are almost ready to compete with yellow balls',
    G3: 'players who are almost ready to compete with yellow balls',
};

export const pickleballRatingDisplayV2 = {
    P1: 'P1',
    P2: 'P2',
    P3: 'P3',
    P4: 'P4',
    P5: 'P5',
};

export const pickleballDescriptionsV2 = {
    P1: 'beginner',
    P2: 'social/casual',
    P3: 'intermediate',
    P4: 'advanced',
    P5: 'expert/pro',
};

export const pickleballDescriptions = {
    P1: 'beginner',
    P2: 'intermediate',
    P3: 'advanced',
    P4: 'expert/pro',
};

export const returnPages = [
    {
        id: 1,
        pattern: /\/$/,
        name: 'to home page',
    },
    {
        id: 2,
        pattern: /\/home/,
        name: 'to home page',
    },
    {
        id: 3,
        pattern: /\/events/,
        name: 'to event page',
    },
    {
        id: 4,
        pattern: /\/clubs/,
        name: 'to club page',
    },
    {
        id: 5,
        pattern: /\/highschool/,
        name: 'to high school page',
    },
    {
        id: 6,
        pattern: /\/power-perks/,
        name: 'to power perks',
    },
];

export const NuoSteps = {
    PKBRSurvey: 'pkbr-survey',
    PKBRRating: 'pkbr-rating',
    UTRSurvey: 'utr-survey',
    UTRRating: 'utr-rating',
    CBRSurvey: 'cbr-survey',
    CBRRating: 'cbr-rating',
    Rating: 'rating',
    ClaimProfile: 'claim-profile',
};

export const ratingDisplaySteps = [
    {
        type: NuoSteps.UTRRating,
        isFromStep: NuoSteps.UTRSurvey,
    },
    {
        type: NuoSteps.CBRRating,
        isFromStep: NuoSteps.CBRSurvey,
    },
    {
        type: NuoSteps.PKBRRating,
        isFromStep: NuoSteps.PKBRSurvey,
    },
];

export const getTennisRatingDescription = (rating) => {
    if (rating < 4) {
        return 'beginner';
    }
    if (rating >= 4 && rating < 8) {
        return 'intermediate';
    }
    if (rating >= 8 && rating < 12) {
        return 'advanced';
    }
    if (rating >= 12) {
        return 'professional';
    }
};

export const getPickleballRatingDescriptionV2 = (rating) => {
    if (typeof rating === 'string' && rating.startsWith('P')) {
        return pickleballDescriptionsV2[rating];
    }
    if (rating < 1) {
        return pickleballDescriptionsV2.P1;
    }
    if (rating < 2) {
        return pickleballDescriptionsV2.P2;
    }
    if (rating >= 2 && rating < 3) {
        return pickleballDescriptionsV2.P3;
    }
    if (rating >= 3 && rating < 4) {
        return pickleballDescriptionsV2.P4;
    }
    if (rating >= 4) {
        return pickleballDescriptionsV2.P5;
    }
};

export const getReturnPageName = (returnPageUrl) => {
    const shouldGotoReturnPage = !!returnPageUrl;

    if (shouldGotoReturnPage) {
        const returnPage = returnPages.find((page) => {
            return page.pattern.test(returnPageUrl);
        });
        return returnPage ? returnPage.name : 'back';
    }

    return 'to home page';
};

export const getRatingForTennis = (rating, profile) => {
    const historicRatings = profile.data?.historicRatings;
    if (rating.status === RatingStatuses.UNRATED || rating.status === RatingStatuses.INACTIVE) {
        if (historicRatings?.historicSinglesRating !== null) {
            return {
                display: historicRatings?.historicSinglesRating,
                value: historicRatings?.historicSinglesRating,
                prefix: 'last known',
            };
        }
        if (historicRatings?.historicDoublesRating !== null) {
            return {
                display: historicRatings?.historicDoublesRating,
                value: historicRatings?.historicDoublesRating,
                prefix: 'last known',
            };
        }

        if (rating.utrRange) {
            if (rating.utrRange.minUtr && rating.utrRange.maxUtr) {
                return {
                    display: `${rating.utrRange.minUtr?.toFixed(2)} - ${rating.utrRange.maxUtr?.toFixed(2)}`,
                    value: (rating.utrRange.minUtr + rating.utrRange.maxUtr) / 2,
                    prefix: 'estimated',
                };
            }
            if (!rating.utrRange.minUtr && (rating.utrRange.lastReliableRating || rating.utrRange.lastReliableRatingDisplay > 0)) {
                return {
                    display: rating.utrRange.lastReliableRating.toFixed(2),
                    value: rating.utrRange.lastReliableRating,
                    prefix: 'last known',
                };
            }
        }
    }

    if (rating.status === RatingStatuses.UNRATED) {
        return {
            display: 'Unrated',
            value: 0,
        };
    }

    return {
        display: rating.value,
        value: rating.value,
    };
};
